import React, { useEffect, useState } from 'react';
import './transfer.css';
import api from '../../axiosInstance';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import Swal from "sweetalert2";
import { useMediaQuery } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import useTotalInvestment from '../../Hook/useTotalInvestment';

function AmountTransfer() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const userId = Number(sessionStorage.getItem("userid"));
  const providerId = Number(sessionStorage.getItem("providerId"));




  const [formData, setFormData] = useState({
    req_from: userId,
    req_to: providerId,
    req_amount: '',
    details: ''
  });



  const [transfers, setTransfers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingTransfer, setEditingTransfer] = useState(null);
  const [page, setPage] = useState(1);
  const [paginationLinks, setPaginationLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendReciveData, setsendReciveData] = useState('parent')


  const totalInvestment = useTotalInvestment();

  const sendRecivebuttonStyle = (type) => ({
    backgroundColor: '#6eb7ec',
    color: 'white',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '4px 12px',
    border: 'none',
    borderRadius: '4px',
    boxShadow: sendReciveData === type ? 'rgba(0, 0, 0, 0.3) 4px 3px 0px 0px' : 'none',
    cursor: 'pointer'
  });



  const handleEdit = (requestEdit) => {
    setFormData({
      req_from: userId,
      req_to: providerId,
      req_amount: requestEdit?.req_amount,
      details: requestEdit?.details,
    });
    setEditingTransfer(requestEdit);
    setShowForm(true);
  };




  const fetchTransfers = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/investmentrequest?${sendReciveData}=${userId}`);
      console.log("Response", response?.data);
      setTransfers(response?.data);
      console.log("transfer state", transfers);
      if (response.status === 200) {


        const filteredLinks = response.data.meta.links
          .filter(link => !isNaN(link.label)) // Ensure it's a number
          .map(link => ({
            ...link,
            active: parseInt(link.label) === page
          }));

        setPaginationLinks(filteredLinks);
      }
    } catch (error) {
      console.error("Error fetching transfer history:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTransfers();
  }, [page, sendReciveData]);

  useEffect(() => {
    console.log("Updated transfers:", transfers?.data);
  }, [transfers, sendReciveData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.req_amount || !formData.details) {
      Swal.fire("Validation Error", "Please fill in all required fields.", "error");
      return;
    }

    try {
      let response;
      if (editingTransfer) {
        response = await api.put(`/investmentrequest/${editingTransfer.id}`, formData);
      } else {
        response = await api.post("/investmentrequest", formData);
      }

      if (response.status === 200) {
        Swal.fire("Success", editingTransfer ? "Transfer updated successfully!" : "Amount transferred successfully!", "success");
        fetchTransfers(page);
        resetForm();
      }
    } catch (error) {
      Swal.fire("Error", `${error.message}`, "error");
    }
  };

  const resetForm = () => {
    setFormData({
      req_from: userId,
      req_to: providerId,
      req_amount: '',
      details: ''
    });
    setShowForm(false);
    setEditingTransfer(null);
  };




  const handleChangeStatus = async (id, status, requestedAmount) => {
    if (providerId !== 0) {
      if (totalInvestment < requestedAmount) {
        Swal.fire("Error", "Total investment amount is less than the requested amount!", "error");
        return; // Stop function execution
      }
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to proceed with the payment?This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Change it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.get(`deductinvestment/${id}/1`);
          Swal.fire("Success!", "The transfer record has been changed.", "success");
          fetchTransfers();
        } catch (error) {
          Swal.fire("Error", `${error?.response?.data?.message}`, "error");
          // console.error("API Error:", error.response?.status, error.response?.data);
        }

      }
    });
  };




  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/investmentrequest/${id}`);
          Swal.fire("Deleted!", "The transfer record has been deleted.", "success");
          fetchTransfers();
        } catch (error) {
          Swal.fire("Error", "Something went wrong!", "error");
        }
      }
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage !== page) {
      setPage(newPage);
    }
  };

  const CustomPagination = () => (
    <div className='d-flex justify-content-center'>
      <Button size="small" variant="contained" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
        <ArrowBack fontSize="small" />
      </Button>

      {(paginationLinks.length > 0 ? paginationLinks : [{ label: "1", active: true }]).map((link, index) => (
        <Button
          size="small"
          key={index}
          variant={link.active ? "contained" : "outlined"}
          onClick={() => handlePageChange(parseInt(link.label))}
        >
          {link.label}
        </Button>
      ))}

      <Button size="small" variant="contained" onClick={() => handlePageChange(page + 1)} disabled={paginationLinks.length === 0 || page >= paginationLinks.length}>
        <ArrowForward fontSize="small" />
      </Button>
    </div>
  );


  const rowsWithIndex = transfers?.data?.map((item, index) => ({
    ...item,
    idindex: index + 1, // start index from 1
  }));

  return (
    <div className='row' style={{ height: "100%" }}>
      <div className='col-md-12 col-12' style={{ position: "relative" }}>
        <div className="d-flex flex-wrap justify-content-between align-items-center p-2">
          <h3 className='distributerfont'>Amount Transfer</h3>
          {providerId !== 0 && (
            <button
              type="button"
              className="rounded btnproduct m-1"
              onClick={() => {
                resetForm();
                setShowForm(!showForm);
              }}
            >
              {showForm ? 'List Transfers' : 'Add Transfer'}
            </button>
          )}

        </div>
        {providerId !== 0 && (
          <div>
            <button className="rounded m-1" style={sendRecivebuttonStyle('parent')} onClick={() => setsendReciveData('parent')}>
              Recived
            </button>
            <button className="rounded m-1" style={sendRecivebuttonStyle('child')} onClick={() => setsendReciveData('child')}>
              Send
            </button>
          </div>)}

        {showForm ? (
          <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center'>
            <div className='formwidthBgImage py-1 px-5 m-3 shadow rounded-5'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6 col-12 mb-3'>
                    <label htmlFor="req_amount" className='form-label'>Transfer Amount</label>
                    <input
                      className='form-control'
                      name="req_amount"
                      type="number"
                      placeholder="Enter amount"
                      value={formData.req_amount}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className='col-md-6 col-12 mb-3'>
                    <label htmlFor="details" className='form-label'>Details</label>
                    <textarea
                      className='form-control'
                      placeholder="Enter details"
                      name="details"
                      value={formData.details}
                      onChange={handleChange}
                      rows="3"
                      required
                    />
                  </div>
                </div>
                <div className='d-flex justify-content-end'>
                  <button type='reset' className='btn btn-secondary m-1' onClick={resetForm}>Cancel</button>
                  <button type='submit' className='btn btn-primary m-1'>{editingTransfer ? 'Update' : 'Submit'}</button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <>
            <div style={{ height: "25rem", width: "100%" }}>
              <DataGrid
                rows={rowsWithIndex}
                columns={[
                  { field: 'idindex', headerName: '#', width: 70 },
                  { field: 'from_name', headerName: 'Name', width: 150 },
                  { field: 'req_amount', headerName: 'Amount', width: 150 },
                  { field: 'details', headerName: 'Details', width: 250 },
                  {
                    field: 'actions',
                    headerName: 'Actions',
                    width: 150,
                    renderCell: (params) => (
                      <div className='d-flex justify-content-start align-items-center'>
                        {providerId !== 0 && sendReciveData !== 'parent' && params?.row?.status == 0 && <IconButton color="primary" onClick={() => handleEdit(params.row)}>
                          <EditIcon />
                        </IconButton>}
                        {providerId !== 0 && sendReciveData !== 'parent' && params?.row?.status == 0 && <IconButton color="secondary" onClick={() => handleDelete(params.row.id)}>
                          <DeleteIcon />
                        </IconButton>}



                        <IconButton
                          color="inherit"
                          disabled={sendReciveData !== "parent"}
                          sx={{
                            color: params?.row?.status == 0 ? "#d32f2f" : "#2e7d32",
                            "&.Mui-disabled": {
                              color: params?.row?.status == 0 ? "#d32f2f80" : "#2e7d3280",
                            },
                          }}
                          onClick={() => {
                            if (sendReciveData === "parent") {
                              handleChangeStatus(params?.row?.id, params?.row?.status, params?.row?.req_amount);
                            }
                          }}
                        >
                          <VerifiedIcon />
                        </IconButton>


                      </div>
                    ),
                  },
                ]}
                loading={loading}
              />
            </div>
            <CustomPagination />
          </>
        )}
      </div>
    </div>
  );
}

export default AmountTransfer;
